import { OutlinedInput, Box } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import useTranslationSetup from "../../utils/useTranslationSetup";
import "./StudentSearchBar.css";

const StudentSearchBar = ({
  students,
  onResults,
  onSearchTermChange,
  searchTerm,
}) => {
  const { t } = useTranslationSetup();
  const handleChange = (e) => {
    const rawValue = e.target.value;
    const filteredValue = rawValue.replace(/[^a-zA-Z\s]/g, "");
    const trimmedValue = filteredValue.trim();

    onSearchTermChange?.(filteredValue);

    if (!trimmedValue) {
      onResults([]);
      return;
    }

    const filtered = students.filter((s) =>
      s.name.toLowerCase().includes(trimmedValue.toLowerCase())
    );
    onResults(filtered);
  };

  const showFloatingLabel = Boolean(searchTerm?.trim());

  return (
    <Box className="student-search-bar-container">
      <label
        className={`floating-label ${showFloatingLabel ? "visible" : ""}`}
        htmlFor="student-search"
      >
        {t("search_by_name")}
      </label>
      <OutlinedInput
        fullWidth
        placeholder={!showFloatingLabel ? t("search_by_name") : ""}
        value={searchTerm}
        onChange={handleChange}
        onFocus={() => onSearchTermChange?.(searchTerm)}
        endAdornment={<SearchIcon />}
        className="search-input"
      />
    </Box>
  );
};

export default StudentSearchBar;
